module.exports = __webpack_public_path__ + "img/undraw_people_search_wctu.65a2dceb.svg";